export const formatPayloadProtocolFilter = (filterData, period) => {
  let payload = {}

  if (filterData.type.value === "protocol") {
    payload = {
      protocol: filterData.data
    }
    return payload
  } else if (filterData.type.value === "date") {
    payload = {
      startDate: period.startDate.format("DD/MM/YYYY"),
      endDate: period.endDate.format("DD/MM/YYYY")
    }
    return payload
  } else {
    payload = {
      startDate: period.startDate.format("DD/MM/YYYY"),
      endDate: period.endDate.format("DD/MM/YYYY"),
      [filterData.type.value]: filterData.data.value
    }

    return payload
  }
}



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/utils/formatPayload.js